import { render, staticRenderFns } from "./CxFocusKpiGrid.vue?vue&type=template&id=482cf581&scoped=true&"
import script from "./CxFocusKpiGrid.vue?vue&type=script&lang=js&"
export * from "./CxFocusKpiGrid.vue?vue&type=script&lang=js&"
import style0 from "./CxFocusKpiGrid.vue?vue&type=style&index=0&id=482cf581&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482cf581",
  null
  
)

export default component.exports